import { Button, Flex, Link } from '@chakra-ui/react';

export function CtaButtons({
  primary,
  secondary,
}: {
  primary: { href: string; label: string; onClick?: () => void };
  secondary?: { href: string; label: string };
}) {
  return (
    <Flex
      direction={{ base: 'column', sm: 'row' }}
      gap={3}
      align="stretch"
      justify="center"
      w="full"
      maxW={{ base: 'full', sm: 'none' }}
    >
      <Button
        as={Link}
        href={primary.href}
        onClick={(event) => {
          if (!primary.onClick) return;
          event.preventDefault();
          primary.onClick();
        }}
        variant="primary"
        size="lg"
        px={8}
        w={{ base: 'full', sm: 'auto' }}
        _hover={{ textDecoration: 'none' }}
      >
        {primary.label}
      </Button>
      {secondary ? (
        <Button
          as={Link}
          href={secondary.href}
          variant="outline"
          size="lg"
          px={8}
          w={{ base: 'full', sm: 'auto' }}
          _hover={{ textDecoration: 'none' }}
        >
          {secondary.label}
        </Button>
      ) : null}
    </Flex>
  );
}
